import { render, staticRenderFns } from "./MessageConfig.vue?vue&type=template&id=0b6c49d6&"
import script from "./MessageConfig.vue?vue&type=script&lang=js&"
export * from "./MessageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6c49d6')) {
      api.createRecord('0b6c49d6', component.options)
    } else {
      api.reload('0b6c49d6', component.options)
    }
    module.hot.accept("./MessageConfig.vue?vue&type=template&id=0b6c49d6&", function () {
      api.rerender('0b6c49d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/MessageConfig/MessageConfig.vue"
export default component.exports